import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<p>We’re sorry. We are not able to obtain a Prior Authorization number at this time. Please try again later.</p>			
			</div>
		);
	}
}